import { axiosSecure, handleError, handleResponse, RequestResponse } from './config';

export const getMemberships = async (): Promise<RequestResponse> => {
   return await axiosSecure
      .get('/memberships')
      .then((response) => handleResponse(response))
      .catch(handleError);
};

export const redeemReferralReward = async (membershipId: string): Promise<RequestResponse> => {
   return await axiosSecure
      .get('/memberships/redeem-referral', { params: { membershipId } })
      .then((response) => handleResponse(response))
      .catch(handleError);
};
